export const blue = {
    50: '#EDF4FD',
    100: '#D1E4FA',
    150: '#B0D0F6',
    200: '#95C0F4',
    300: '#7AB0F1',
    400: '#5E9FEE',
    500: '#438FEB',
    600: '#2A75CF',
    700: '#1F5FAD',
    800: '#184A88',
    850: '#113662',
    900: '#09213D',
    950: '#020C17'
};

//# sourceMappingURL=blue.js.map